.cardPositive {
  background:
    linear-gradient(
      90deg,
      var(--background-soft) 0%,
      color-mix(in srgb, var(--surface-success) 50%, transparent) 100%
    ),
    var(--background-soft);
}

.cardNegative {
  background:
    linear-gradient(
      90deg,
      var(--background-soft) 0%,
      color-mix(in srgb, var(--surface-critical) 50%, transparent) 100%
    ),
    var(--background-soft);
}

.cardWarning {
  background:
    linear-gradient(
      90deg,
      var(--background-soft) 0%,
      color-mix(in srgb, var(--surface-warning) 50%, transparent) 100%
    ),
    var(--background-soft);
}

.bullish {
  color: var(--viz-bullish);
}

.bearish {
  color: var(--viz-bearish);
}

.warning {
  color: var(--text-warning);
}

.themeTextIndigo {
  color: var(--kg-theme);
}

.themeTextTeal {
  color: var(--text-decorative-teal);
}

.themeTextPurple {
  color: var(--text-decorative-purple);
}

.themeTextGold {
  color: var(--text-decorative-gold);
}

.themeFillIndustry {
  background-color: var(--kg-theme);
  color: var(--text-default);
}

.themeFillFinancial {
  background-color: var(--icon-decorative-purple);
  color: var(--text-inverse);
}

.themeFillMacro {
  background-color: var(--icon-decorative-teal);
  color: var(--text-inverse);
}
